import { useSnackbar } from 'notistack';
import { useApi } from '../../shared/context';
import { DealExcludedLender } from '../../shared/models';
import { useMutation, useQueryClient } from 'react-query';
import { getResponseData } from '../../shared/utils/axios';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { CerebroTextButton } from '../../shared/components';
import { QueryKeys } from '../../shared/hooks';

interface DeleteExcludedLenderDialogProps {
	dealGuid: string | undefined;
	lender: DealExcludedLender | null;
	close: () => void;
}

export const DeleteExcludedLenderDialog: React.FC<DeleteExcludedLenderDialogProps> = ({ dealGuid, lender, close }) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onDeleteConfirmation = () => {
		if (lender !== null) deleteExcludedLender(lender);
	};

	const { mutate: deleteExcludedLender } = useMutation<void, unknown, DealExcludedLender>(
		lenderToDelete =>
			getResponseData(
				api.delete<void>(CerebroApiEndpoints.ExcludedLenders.Specific(dealGuid, lenderToDelete.guid))
			),
		{
			onMutate: () => {
				close();
			},
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.ExcludedLenders(dealGuid));
				snackbar.enqueueSnackbar('Excluded lender successfully deleted.', { variant: 'success' });
				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem deleting the excluded lender.', {
					variant: 'error',
				});
			},
		}
	);

	return (
		<Dialog open={lender !== null} onClose={close}>
			<DialogTitle>Confirm Delete</DialogTitle>
			<DialogContent>
				<DialogContentText>Are you sure you no longer want to exclude {lender?.bankName}?</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onDeleteConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
